var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 61.84 61.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #8a94ab;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.42,
    y: 3.28,
    width: 55,
    height: 55
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_650"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    className: "cls-3",
    d: "M58.83,3.28h0v34.89c0,11.34-9.19,20.52-20.52,20.52H3.42L58.83,3.28Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_573"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.63,47.09c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41l19.1-19.1c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-19.1,19.1c-.2.2-.45.29-.71.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_574"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.99,49.2c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41l14.58-14.58c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-14.58,14.58c-.2.2-.45.29-.71.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_575"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.48,49.21c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41l7-7c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-7,7c-.2.2-.45.29-.71.29Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandButton);
export default __webpack_public_path__ + "static/media/Expand Button.16627da554efe561ae55dabe0d98bf0a.svg";
export { ForwardRef as ReactComponent };